/**
 * Sanitizes Contentful URLs that contain literal template placeholders like [locale] or [project].
 * These are entered by content authors who mistakenly use Next.js route param syntax in CMS URLs.
 */
export function sanitizeContentfulUri(uri: string): string {
  return uri.replace(/\/\[locale\]/g, '').replace(/\/\[project\]/g, '')
}
